import { Text, View } from '@react-pdf/renderer';

import DocumentSeller from './Entities/Seller';

import DocumentCustomer from './Entities/Customer';

export default function DocumentEntities ( { order, state, contacts, legalData } ) {

    return (

        <View style={ { flexDirection: "row", gap: 10, flexWrap: "nowrap" } }>

            <DocumentCustomer state={ state } order={ order } contacts={ contacts } />

            <DocumentSeller contacts={ contacts } legalData={ legalData } />

        </View>

    );

};